import { render, staticRenderFns } from "./DevComponents.vue?vue&type=template&id=6b7baae9&"
import script from "./DevComponents.vue?vue&type=script&lang=js&"
export * from "./DevComponents.vue?vue&type=script&lang=js&"
import style0 from "./DevComponents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports